import { Convergence } from './Convergence.js';

export class BoundedConvergence extends Convergence {
    constructor(start, end, min, max, dampingFactor) {
        super(start, end, dampingFactor);
        this._min = min;
        this._max = max;
    }

    get min() { return this._min; }
    get max() { return this._max; }

    increaseEndBy(value) { this.end = this._end + value; }
    decreaseEndBy(value) { this.end = this._end - value; }

    get end() { return this._end; }
    set end(value) {
        this._end = value;

        if (this._end < this._min) { this._end = this._min; }
        else if (this._end > this._max) { this._end = this._max; }
    }

    reset(start, end, min, max, dampingFactor) {
        this._start = start !== null ? start : this._originalStart;
        this._end = end !== null ? end : this._originalEnd;
        this._min = min !== null ? min : this._min;
        this._max = max !== null ? max : this._max;
        this._dampingFactor = dampingFactor !== null ? dampingFactor : this._dampingFactor;
    }
}